import React,  { useState, useLayoutEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader && animationHandler="fade"
import { Link } from "react-router-dom";
import {Link as MUILink} from '@mui/material';
import { Carousel } from 'react-responsive-carousel';
import AnimatedText from "components/sections/TextAnimation/AnimatedText";
import MDBox from "dashboard/components/MDBox";
import { motion } from "framer-motion";


const Header = ({data, parseContent, withMenu}) => {
  const [replay, setReplay] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useLayoutEffect(() => {
    // Function to update the 'isMobile' state based on the window width
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Add a window resize event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const container = {
    visible: {
      transition: {
        staggerChildren: 0.015
      }
    }
  };
  
  const ancher = {
    visible : {
      transition:{ 
        ease: "linear",
        duration: 1.5,
        delay : 2,
        type: "spring", 
        stiffness: 100
      },
      
      opacity : 1
    },
    hidden : {
      
      opacity : 0
    }
  }

  const subtitle = {
    visible : {
      transition:{ 
        ease: "easeInOut", 
        duration: 0.35, 
        delay : .8
      },
      y : 0,
      opacity : 1
    },
    hidden : {
      y :60,
      opacity : 0
    }
  }

  const images = {
    visible : {
      transition:{ 
        ease: "easeInOut", 
        duration: 10,

      },
      scale : 1.1
    },
    hidden : {
      scale:1
    }
  }

  const sidRow = {
    visible : {
      transition:{ 
        ease: "easeInOut", 
        duration: .6,

      },
      width : isMobile ? "100%" : "40%",
      opacity : 1
    },
    hidden : {
      width :0,
      opacity : 0
    }
  }

  const playCurrentSlide = index =>{
    setReplay(index);
  }

  return (
    <header  id="Header">
      <MDBox sx={{marginTop : 0}} className="intro custom-carousel" >
        <Carousel onChange={playCurrentSlide} showThumbs={false} infiniteLoop swipeable emulateTouch stopOnHover  autoPlay interval={5000} > 
            {data ? data?.cards?.map(item=>item.img).map( (url, i) => (<div onMouseDown={e=>e.stopPropagation()} key={data?.cards[i].title} style={{position:"relative"}} >
              <motion.img initial="hidden" animate={replay === i ? "visible" : "hidden"} variants={images}  src={`${process.env.REACT_APP_PUBLIC_URL}/img/headers/${url}`} alt={data?.cards[i].title} />
              <motion.div  initial="hidden" animate={replay === i ? "visible" : "hidden"} variants={sidRow} className="intro-text" >
                  <motion.div variants={container} initial="hidden" animate={replay === i ? "visible" : "hidden"}  className="container">
                  <AnimatedText type="heading1" text={data?.cards[i].title} />
                  <motion.h4 initial="hidden" animate={replay === i ? "visible" : "hidden"} variants={subtitle}  style={{color: "white", opacity: 1, transform: "none", marginBottom : 10}} >{parseContent(data?.cards[i].text)}</motion.h4>
                  <motion.div initial="hidden" style={{marginTop:"20px"}} animate={replay === i ? "visible" : "hidden"}  variants={ancher}   >
                  {data?.cards[i].link?.type === 2 ? (
                    <a  data-scroll href={`#${data?.cards[i].link.name || "#"}`} className="btn btn-custom btn-lg page-scroll"  style={{ textAlign: 'center', cursor:"pointer" }}>
                      Lire plus
                    </a>) : <MUILink sx={{ textAlign: 'center', cursor:"pointer", fontSize:"15px", color:"white !important" }} className="btn btn-custom btn-lg" component={Link}   to={`${data?.cards[i].link?.slug || ""}`} >Lire plus</MUILink>}
                  </motion.div>
                  </motion.div>
              </motion.div>
            </div>)) : "Loading..."}
        </Carousel>
      </MDBox>
    </header>
  );
};

export default Header